__turbopack_context__.v({
  "card": "PYejGW_card",
  "dates": "PYejGW_dates",
  "hero": "PYejGW_hero",
  "image": "PYejGW_image",
  "title": "PYejGW_title",
});
